import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import DeeplinkSet from '@/pages/deeplink-set'

export const Route = createFileRoute('/app/deeplink-set/$setId')({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { setId } = Route.useParams()
  return <DeeplinkSet setId={Number(setId)} />
}
